"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TitleRoot = exports.Title = exports.Root = exports.ImageRoot = exports.Image = exports.BreadcrumbsRoot = void 0;
var _mui = require("@ori-ui/mui");
var _presentationUtils = require("@ori/presentation-utils");
var _constants = require("./constants");
const Root = exports.Root = (0, _mui.styled)('div', {
  shouldForwardProp: (0, _presentationUtils.shouldForwardProp)()
})(({
  backgroundColor,
  showBackground,
  textColor,
  theme
}) => ({
  background: showBackground ? undefined : backgroundColor ?? theme.palette.common.white,
  color: textColor ?? theme.palette.text.primary,
  display: 'flex',
  flexDirection: 'column',
  justifyContent: showBackground ? 'start' : 'center',
  overflow: 'hidden',
  position: 'relative',
  [`.${_mui.breadcrumbsClasses.root}`]: {
    color: textColor ?? theme.palette.text.primary
  }
}));
const BreadcrumbsRoot = exports.BreadcrumbsRoot = (0, _mui.styled)('div', {
  shouldForwardProp: (0, _presentationUtils.shouldForwardProp)()
})(({
  renderSeparately,
  theme
}) => ({
  left: renderSeparately ? undefined : theme.spacing(3),
  margin: renderSeparately ? theme.spacing(3) : 0,
  position: renderSeparately ? 'relative' : 'absolute',
  top: renderSeparately ? undefined : theme.spacing(3),
  zIndex: 1,
  [theme.breakpoints.up('sm')]: {
    left: renderSeparately ? undefined : theme.spacing(6),
    top: renderSeparately ? undefined : theme.spacing(6)
  }
}));
const TitleRoot = exports.TitleRoot = (0, _mui.styled)('div', {
  shouldForwardProp: (0, _presentationUtils.shouldForwardProp)()
})(({
  hasBreadcrumbs,
  paddingOnlyOnTop,
  theme
}) => ({
  alignItems: 'center',
  display: 'flex',
  justifyContent: 'center',
  padding: paddingOnlyOnTop ? theme.spacing(6, 3, 0) : theme.spacing(hasBreadcrumbs ? 10 : 6, 3, 6, 3),
  position: 'relative',
  [theme.breakpoints.up('sm')]: {
    padding: paddingOnlyOnTop ? theme.spacing(8, 3, 0) : theme.spacing(hasBreadcrumbs ? 14 : 10, 6, 10, 6)
  }
}));
const Title = exports.Title = (0, _mui.styled)(_mui.Typography, {
  shouldForwardProp: (0, _presentationUtils.shouldNotForwardProp)(['extraLongHeadline'])
})(({
  extraLongHeadline,
  theme
}) => ({
  display: '-webkit-box',
  overflow: 'hidden',
  textAlign: 'center',
  textOverflow: 'ellipsis',
  WebkitBoxOrient: 'vertical',
  WebkitLineClamp: 3,
  [theme.breakpoints.up('sm')]: {
    maxWidth: 860,
    WebkitLineClamp: 2
  },
  [theme.breakpoints.up('md')]: {
    fontSize: extraLongHeadline ? '4rem' : undefined,
    lineHeight: 1.4
  }
}));
const ImageRoot = exports.ImageRoot = (0, _mui.styled)('div')(({
  theme
}) => ({
  position: 'relative',
  height: _constants.TOP_BANNER_MOBILE_HEIGHT,
  width: '100%',
  [theme.breakpoints.up('sm')]: {
    height: _constants.TOP_BANNER_DESKTOP_HEIGHT
  }
}));
const Image = exports.Image = (0, _mui.styled)('img')({
  height: '100%',
  left: 0,
  objectFit: 'cover',
  objectPosition: '50% 50%',
  position: 'absolute',
  top: 0,
  width: '100%'
});
//# sourceMappingURL=styles.js.map